<template>
  <li class="row">
    <div class="col-xs-4 col-sm-12">
      <img :src="talent.profile_image_url" />
      <span class="position">{{ priority }}</span>
    </div>
    <div class="col-xs-8 col-sm-12">
      <div class="description">
        <h4>{{ talent.name }}</h4>
        <p>{{ talent.profile.tagline }}</p>
        <p v-if="!$hideSocialMediaReferences" :title="`${talent.profile.highest_followers} followers`">
          <i :class="['fab', talent.profile.highest_followers_icon]"></i> {{ talent.profile.highest_followers | abbreviatedNumber }} followers
        </p>

        <a href="" @click.prevent="handleRemoveCallback">
          Remove
          <i v-if="removingShortlistedTalent" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    talent: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    booking: {
      type: Object,
      required: true
    },
    removeShortlistedTalent: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      removingShortlistedTalent: false
    }
  },

  computed: {
    /**
     * Because talent can be removed from the shortlist we'll temporarily use the index
     * of the talent within the array of shortlisted talent to determine their
     * priority to save having to update all talent if we remove a single one.
     *
     * NOTE: This will probably have to change if we need to implement the ability to
     * re-order shortlists or add new talent to the shortlist.
     *
     * @return int
     */
    priority () {
      return this.index + 1
    }
  },

  methods: {

    /**
     * Handle removing a talent from the shortlist.
     *
     * @return Promise
     */
    handleRemoveCallback () {
      this.removeShortlistedTalent(this.talent.id)
    }
  }
}
</script>
